import React from 'react';
import PropTypes from 'prop-types';
import { MAIN_COLOR } from '../../../styles/variables';

const ConfirmIcon = ({ color, size }) => {
  return (
    <svg
      className="icon-confirm"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 30 30"
    >
      <defs>
        <path
          id="icon-confirm"
          d="M23.786 11.22A9.955 9.955 0 0 1 25 16c0 5.523-4.477 10-10 10S5 21.523 5 16 9.477 6 15 6c2.365 0 4.538.82 6.25 2.193l-1.425 1.425a8 8 0 1 0 2.47 3.093l-6.586 6.586a1 1 0 0 1-1.416-.001l-3.375-3.39a1 1 0 0 1 1.417-1.41l2.668 2.678 8.23-8.23a1 1 0 1 1 1.415 1.414l-.862.862z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="icon-confirmb" fill="#fff">
          <use xlinkHref="#icon-confirm" />
        </mask>
        <use fill={color || MAIN_COLOR} fillRule="nonzero" xlinkHref="#icon-confirm" />
        <g fill={color || MAIN_COLOR} mask="url(#icon-confirmb)">
          <path d="M0 0h30v30H0z" />
        </g>
      </g>
    </svg>
  );
};

ConfirmIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

ConfirmIcon.defaultProps = {
  color: MAIN_COLOR,
  size: '30px',
};

export default ConfirmIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/Confirm/index.js